
<template>
  <div class="fill-height">
    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
         فایل اکسل
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


<v-card-text>

          <v-form  ref="form" @submit.prevent="save5" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">
                <v-autocomplete
                    :items="items"
                    v-model="template"
                    label="انتخاب قالب"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('template')"
                />

              </v-col>
              <v-col cols="12" sm="6"
                     md="4">
                <v-file-input
                    outlined
                    dense
                    v-model="file"
                    show-size
                    :error-messages="getError('file')"
                    label="فایل"
                ></v-file-input>

              </v-col>



            </v-row>
            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  depressed
                  small
                  color="primary"
                  class=" pr-5 pl-5"
                  type="submit"
                  :loading="loading"
              >
                ارسال پیام
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

</template>

<script>
import ExcelFile_se from "./excelFile_se";
import {mapMutations} from "vuex";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
  },

  data() {
    return {
      bindingErrors: [],
      valid: true,
      loading:false,
      template: '',
      file: [],
      items: [],
    }
  },

  methods: {
    close(){
      this.template=""
      this.file= []
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },


    closed() {
      this.loading=false
      this.bindingErrors = []
      this.$emit('update:dialogStatus', false)
    },

    save5() {
      this.loading=true
      this.bindingErrors = []
      this.$progress({message: 'درحال ارسال پیام...'}, true)
      ExcelFile_se.save(this.file, this.template).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success',message:'در حال ارسال پیام می باشد و گزارش ارسال را بررسی کنید!!'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading=false
          this.$root.$emit('Progress')
          this.$snack({type: 'error',message:'خطایی در فایل رخ داده است!'})
          this.bindingErrors = response.response.data;
        }
      })
    },
    handleInput (value) {
      this.$emit('input', value)
    },
    fillDataItems() {
    ExcelFile_se.getPage().then(response => {
        this.items = response.data.templateList
    });
    },
    // getTemplateList() {
    //   ListBox.templateList().then(response => {
    //     this.items = response.data
    //   })
    //
    // },
  },
created() {
  this.setDrawer(false)
   this.fillDataItems()
}
}
</script>


